<app-base-modal
  [title]="'Связка/Отвязка Артикулов конкурентов'"
>
  @if (isLoading) {
    <app-loader/>
  }
  <div class="sync-competitor-article-list-search-row">
    <mat-form-field
      appearance="outline"
      class="sync-competitor-article-list-search"
    >
      <mat-label>Поиск</mat-label>
      <input
        matInput
        [(ngModel)]="searchTerm"
        (blur)="handleSearch()"
        (keydown.enter)="handleEnterSearch($event)"
      >
    </mat-form-field>
  </div>
  <mat-tab-group (selectedTabChange)="handleTabChange($event)">
    @for (tab of tabsData; track $index) {
      <mat-tab [label]="tab.title">
        @if (!getDataByTab().length) {
          <div class="sync-competitor-article-list-empty">
            {{ tab.emptyText }}
          </div>
        } @else {
          <app-carousel
            [itemsCount]="getDataByTab().length"
            [gap]="20"
            [visibleItems]="3"
            (currentIndexChange)="handleIndexChange($event)"
          >
            <div class="sync-competitor-article-list-cards">
              @for (competitorArticle of getDataByTab(); track $index) {
                <div
                  app-competitor-article-sync-card
                  class="sync-competitor-article-list-card"
                  [competitorArticle]="competitorArticle"
                  [btnKey]="tab.btnKey"
                  [selectedData]="selectedData()"
                  (handleSelectData)="handleSelectData($event)"
                ></div>
              }
            </div>
          </app-carousel>
        }
      </mat-tab>
    }
  </mat-tab-group>
  <div class="buttons-container">
    <button
      mat-button
      color="primary"
      [disabled]="!selectedData().length"
      (click)="handleBtn()"
    >
      {{ selectedTabIndex() === 0 ? 'Отвязать' : 'Привязать' }}
    </button>
    <button
      mat-button
      color="warn"
      (click)="closeDialog('cancel')"
    >
      Закрыть
    </button>
  </div>
</app-base-modal>
